const productsToReviews = ["coogee"];

const extractProductName = (url) => {
  const regex = /\/products\/([^\/?#]+)/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

const url = window.location.href;
const productName = extractProductName(url);
const belongsToProducts = productsToReviews.includes(productName);

if (belongsToProducts) {
  document.addEventListener("DOMContentLoaded", function () {
    const mainStampedBlock = document.querySelector("#stamped-main-widget");

    if (mainStampedBlock && url.includes("#stamped-main-widget")) {
      // Function to execute after a node is added
      const executeOnce = () => {
        const button = document.querySelector(
          ".stamped-summary-actions-newreview"
        );
        setTimeout(() => {
          button.click();
        }, 500);
      };

      // Callback function to execute when mutations are observed
      const callback = function (mutationsList, observer) {
        for (let mutation of mutationsList) {
          if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            executeOnce();
            observer.disconnect(); // Stop observing after the first mutation
            break;
          }
        }
      };

      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);

      // Start observing the target node for configured mutations
      observer.observe(mainStampedBlock, { childList: true });
    }
  });
}
